export enum Hotkeys {
  ESCAPE = 'Escape',
  ENTER = 'Enter'
}
